webpackJsonp([1],{

/***/ "26dS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/main_components/amountSummary.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var amountSummary = ({
    name: "amountSummary",
    props: {
        titles: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        columnNames: {
            type: Array,
            default: function _default() {
                return ['Alipay', 'WeChat Pay', 'Credit Card', 'Paypal', 'Debit Card', 'Unionpay', 'Venmo'];
            }
        },
        counts: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        values: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        currency: {
            type: String,
            default: ''
        }

    },
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a9cc176","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/main_components/amountSummary.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('li',{staticClass:"m-cell-tab"},[_c('ul',{staticClass:"m-cell-ptab"},_vm._l((_vm.titles),function(title,index){return _c('li',{key:index},[_vm._v(_vm._s(title))])})),_vm._v(" "),_c('p',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"m-cell-tab-unit m-cell-tab-unit-left"},_vm._l((_vm.columnNames),function(colName,index){return _c('p',{key:index,staticClass:"m-cell-tab-unit-title"},[_vm._v(_vm._s(colName))])})),_vm._v(" "),_c('div',{staticClass:"m-cell-tab-unit m-cell-tab-unit-middle"},_vm._l((_vm.counts),function(count,index){return _c('p',{key:index,staticClass:"m-cell-tab-unit-content"},[_c('span',[_vm._v(_vm._s(count))])])})),_vm._v(" "),_c('div',{staticClass:"m-cell-tab-unit m-cell-tab-unit-right"},_vm._l((_vm.values),function(value,index){return _c('p',{key:index,staticClass:"m-cell-tab-unit-content"},[_c('span',[_vm._v(_vm._s(value))]),_c('label',[_vm._v(_vm._s(_vm.currency))])])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var main_components_amountSummary = (esExports);
// CONCATENATED MODULE: ./src/views/main_components/amountSummary.vue
function injectStyle (ssrContext) {
  __webpack_require__("YJVw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a9cc176"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  amountSummary,
  main_components_amountSummary,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_main_components_amountSummary = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var home = ({
    name: 'home',
    components: {
        'AmountSummary': views_main_components_amountSummary
    },
    data: function data() {
        return {
            pageInfo: {
                title: "首页"
            },
            scrollData: {
                noFlag: false //暂无更多数据显示
            },
            current: 1,
            size: 10,
            perpage: 10,
            totalSize: 0,
            startDate: this.$util.formatDate(new Date(), ''),
            endDate: this.$util.formatDate(new Date(), ''),
            countmap: {},
            tablelist: [],
            value1: this.$util.formatDate(new Date(), ''),
            calendarShow: false,
            defaultDate: new Date(),
            currentSelectedDate: this.$util.formatDate(new Date(), ''),
            currentSelectedDateShow: this.$util.formatDate(new Date(), '').replace(/-/g, "/"),
            sales: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            refund: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            netSales: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            countMap: {},
            totalMap: {},
            currency: "",
            tip: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            tax: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            convenientFee: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            voids: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            svc: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            otherFeeAmount: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            customTax: {
                columnNames: [],
                counts: [],
                amounts: []
            },
            sumAmount: {},
            channel: ['total', 'alipay', 'wechatpay', 'creditcard', 'paypal', 'debitcard', 'unionpay', 'venmo'],
            columnNames: {
                alipay: 'Alipay', wechatpay: 'WeChat Pay', creditcard: 'Credit Card', paypal: 'Paypal', debitcard: 'Debit Card', unionpay: 'Unionpay', venmo: 'Venmo'
            },
            showOtherFeeAmount: false,
            showCustomTax: false
        };
    },

    computed: {
        userInfo: function userInfo() {
            return this.$store.state.userInfo ? this.$store.state.userInfo : {};
        }
    },
    methods: {
        init: function init() {
            this.$store.commit("getuserinfo", { refresh: true });
            //this.$ajax.getOpenid(this);
            this.$util.title(this.pageInfo.title);
        },
        setPaymentChannel: function setPaymentChannel(data, type) {
            //console.log(data,type)
            if (data != undefined) {
                data = data.toLowerCase();
                type = type.toLowerCase();
            }
            return data.indexOf(type) >= 0;
        },
        handelChange: function handelChange(date, formatDate) {
            this.currentSelectedDate = this.$util.formatDate(date, '');
            this.currentSelectedDateShow = this.currentSelectedDate.replace(/-/g, "/");
            this.getlist();
        },
        tapCanlendar: function tapCanlendar() {
            this.calendarShow = this.calendarShow == true ? false : true;
        },
        onRefresh: function onRefresh(done) {
            this.perpage = this.perpage * this.current;
            this.current = 1;
            this.tablelist = [];
            this.getlist(function () {
                done();
            });
        },
        onInfinite: function onInfinite(done) {
            var _this = this;

            console.log('onInfinite');
            this.current = 1;
            //走完数据调用方法
            this.getlist(function () {
                _this.scrollData.noFlag = true;
                done();
            });
        },
        modifyResult: function modifyResult(obj) {
            for (var k in obj) {
                if (!obj[k]) {
                    obj[k] = 0;
                }
            }
            return obj;
        },
        getlist: function getlist(done) {
            var _this2 = this;

            this.$Indicator.open('loading...');
            console.log('getlist');
            this.ajaxPromiseAll(done);
            return;
            console.log(this.currentSelectedDate);
            console.log(this.$util.formatDate(this.currentSelectedDate, '', 8) + " 00:00:00");
            console.log(this.$util.formatDate(this.currentSelectedDate, '', 8) + " 23:59:59");
            var d = new Date();
            console.log(-d.getTimezoneOffset() / 60);
            //console.log('home=>getlist=>this.$ajax.ajaxUrlPart: ',this.$ajax.ajaxUrlPart);
            this.$ajax.post(this.$ajax.ajaxUrlPart + '/wxoauser/summary', {
                // this.$ajax.post(this.$ajax.ajaxUrlPart + '/app-pos-report/summary/v2', {
                startDate: this.$util.formatDate(this.currentSelectedDate, '', 8) + " 00:00:00",
                endDate: this.$util.formatDate(this.currentSelectedDate, '', 8) + " 23:59:59",
                //page: this.current,//this.current == undefined ? 1 : this.current,
                //size: this.perpage,//parseInt(this.current) * parseInt(this.perpage),
                transactionStatus: '100',
                page: 1,
                size: 1000,
                timezone: -d.getTimezoneOffset() / 60
            }).then(function (result) {
                done == undefined ? '' : done();
                //console.log('done',done);
                _this2.$ajax.handleAjaxResult(_this2, result);
                if (result && result.ret_code == '000100') {
                    console.log('获取数据成功');
                    console.log(result);
                    if (result.countMap) {
                        _this2.countMap = result.countMap;
                    } else {
                        _this2.countMap = {
                            "refundCounts": 0,
                            "salesAmount": 0,
                            "netSalesCounts": 0,
                            "tip": 0,
                            "svc": 0,
                            "salesCounts": 0,
                            "netSalesAmount": 0,
                            "refundAmount": 0,
                            "tax": 0,
                            'customTax': 0,
                            'otherFeeAmount': 0,
                            "convenientFee": 0,
                            "voidsAmount": 0,
                            "voidsCounts": 0
                        };
                    }
                    if (result.sales) {
                        _this2.sales = result.sales;
                        _this2.sales = _this2.modifyResult(_this2.sales);
                    } else {
                        _this2.sales = {
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        };
                    }
                    if (result.refund) {
                        _this2.refund = result.refund;
                        _this2.refund = _this2.modifyResult(_this2.refund);
                    } else {
                        _this2.refund = {
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        };
                    }
                    if (result.netSales) {
                        _this2.netSales = result.netSales;
                        _this2.netSales = _this2.modifyResult(_this2.netSales);
                    } else {
                        _this2.netSales = {
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        };
                    }
                    if (result.tip) {
                        _this2.tip = result.tip;
                        _this2.tip = _this2.modifyResult(_this2.tip);
                    } else {
                        _this2.tip = {
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        };
                    }
                    if (result.tax) {
                        _this2.tax = result.tax;
                        _this2.tax = _this2.modifyResult(_this2.tax);
                    } else {
                        _this2.tax = {
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        };
                    }
                    if (result.convenientFee) {
                        _this2.convenientFee = result.convenientFee;
                        _this2.convenientFee = _this2.modifyResult(_this2.convenientFee);
                    } else {
                        _this2.convenientFee = {
                            "wechatCounts": 0,
                            "alipayCounts": 0,
                            "wechatAmount": 0,
                            "creditCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0
                        };
                    }
                    if (result.void) {
                        _this2.voids = result.void;
                        _this2.voids = _this2.modifyResult(_this2.voids);
                    } else {
                        _this2.voids = {
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        };
                    }
                    if (result.svc) {
                        _this2.svc = result.svc;
                        _this2.svc = _this2.modifyResult(_this2.svc);
                    } else {
                        _this2.svc = {
                            alipayAmount: 0,
                            alipayCounts: 0,
                            creditAmount: 0,
                            creditCounts: 0,
                            wechatAmount: 0,
                            wechatCounts: 0
                        };
                    }
                    if (result.customTax) {
                        _this2.customTax = result.customTax;
                        _this2.customTax = _this2.modifyResult(_this2.customTax);
                    } else {
                        _this2.customTax = {};
                    }
                    if (result.otherFeeAmount) {
                        _this2.otherFeeAmount = result.otherFeeAmount;
                        _this2.otherFeeAmount = _this2.modifyResult(_this2.otherFeeAmount);
                    } else {
                        _this2.otherFeeAmount = {};
                    }
                    _this2.currency = result.currency;
                }
            }).catch(function (err) {
                //console.log('home=>getlist=>err: ',err);
                //console.log('home=>getlist=>err.status: ',err.status);
                _this2.$ajax.handleAjaxError(_this2, err);
            });
        },
        processData: function processData(data) {
            var _this3 = this;

            console.log('processData', data);
            if (data.length > 0) {
                var _data = {
                    columnNames: [],
                    counts: [],
                    amounts: []
                };
                this.sales = JSON.parse(JSON.stringify(_data));
                this.tip = JSON.parse(JSON.stringify(_data));
                this.tax = JSON.parse(JSON.stringify(_data));
                this.convenientFee = JSON.parse(JSON.stringify(_data));
                this.svc = JSON.parse(JSON.stringify(_data));
                this.refund = JSON.parse(JSON.stringify(_data));
                this.voids = JSON.parse(JSON.stringify(_data));
                this.netSales = JSON.parse(JSON.stringify(_data));
                this.otherFeeAmount = JSON.parse(JSON.stringify(_data));
                this.customTax = JSON.parse(JSON.stringify(_data));
                this.totalMap = {
                    "refundCounts": 0,
                    "salesAmount": 0,
                    "netSalesCounts": 0,
                    "tip": 0,
                    "svc": 0,
                    "salesCounts": 0,
                    "netSalesAmount": 0,
                    "refundAmount": 0,
                    "tax": 0,
                    'customTax': 0,
                    'otherFeeAmount': 0,
                    "convenientFee": 0,
                    "voidsAmount": 0,
                    "voidsCounts": 0
                };
                console.log('Promise', data);

                data.forEach(function (el) {
                    var _channel = el.searchChannel;
                    _this3.currency = el.currency;
                    if (_channel) {
                        if (el.countMap['salesAmount'] || el.countMap['salesAmount'] === 0) {
                            _this3.sales.columnNames.push(_this3.columnNames[_channel]);
                            _this3.sales.amounts.push(el.countMap['salesAmount']);
                            _this3.sales.counts.push(el.countMap['salesCounts']);
                        }

                        if (el.countMap['tipAmount'] || el.countMap['tipAmount'] === 0) {
                            _this3.tip.columnNames.push(_this3.columnNames[_channel]);
                            _this3.tip.amounts.push(el.countMap['tipAmount']);
                            _this3.tip.counts.push(el.countMap['tipCount']);
                        }

                        if (el.countMap['taxAmount'] || el.countMap['taxAmount'] === 0) {
                            _this3.tax.columnNames.push(_this3.columnNames[_channel]);
                            _this3.tax.amounts.push(el.countMap['taxAmount']);
                            _this3.tax.counts.push(el.countMap['taxCount']);
                        }

                        if (el.countMap['convenientFeeAmount'] || el.countMap['convenientFeeAmount'] === 0) {
                            _this3.convenientFee.columnNames.push(_this3.columnNames[_channel]);
                            _this3.convenientFee.amounts.push(el.countMap['convenientFeeAmount']);
                            _this3.convenientFee.counts.push(el.countMap['convenientFeeCount']);
                        }

                        // if(el.countMap['svc'] || el.countMap['svc'] ===0){
                        //     this.svc.columnNames.push(this.columnNames[_channel]) 
                        //     this.svc.amounts.push(el.countMap['svc'])
                        //     this.svc.counts.push(el.countMap['svcCount'])
                        // }

                        if (el.countMap['otherFeeAmount'] || el.countMap['otherFeeAmount'] === 0) {
                            if (el.countMap['otherFeeAmount']) {
                                _this3.showOtherFeeAmount = true;
                            }
                            _this3.otherFeeAmount.columnNames.push(_this3.columnNames[_channel]);
                            _this3.otherFeeAmount.amounts.push(el.countMap['otherFeeAmount']);
                            _this3.otherFeeAmount.counts.push(el.countMap['otherFeeCount']);
                        }

                        if (el.countMap['customTaxAmount'] || el.countMap['customTaxAmount'] === 0) {
                            if (el.countMap['customTaxAmount']) {
                                _this3.showCustomTax = true;
                            }
                            _this3.customTax.columnNames.push(_this3.columnNames[_channel]);
                            _this3.customTax.amounts.push(el.countMap['customTaxAmount']);
                            _this3.customTax.counts.push(el.countMap['customTaxCount']);
                        }

                        if (el.countMap['refundAmount'] || el.countMap['refundAmount'] === 0) {
                            _this3.refund.columnNames.push(_this3.columnNames[_channel]);
                            _this3.refund.amounts.push(el.countMap['refundAmount']);
                            _this3.refund.counts.push(el.countMap['refundCounts']);
                        }

                        if (el.countMap['voidAmount'] || el.countMap['voidAmount'] === 0) {
                            _this3.voids.columnNames.push(_this3.columnNames[_channel]);
                            _this3.voids.amounts.push(el.countMap['voidAmount']);
                            _this3.voids.counts.push(el.countMap['voidCount']);
                        }

                        if (el.countMap['netSalesAmount'] || el.countMap['netSalesAmount'] === 0) {
                            _this3.netSales.columnNames.push(_this3.columnNames[_channel]);
                            _this3.netSales.amounts.push(el.countMap['netSalesAmount']);
                            _this3.netSales.counts.push(el.countMap['netSalesCounts']);
                        }
                    } else {
                        _this3.totalMap = el.countMap ? el.countMap : _this3.totalMap;
                    }
                });
            }
        },
        getChannelSum: function getChannelSum(data) {
            var d = new Date();
            console.log(this.$ajax.ajaxUrlPart);
            return this.$ajax.post(this.$ajax.ajaxUrlPart + '/wxoauser/summary', {
                startDate: this.$util.formatDate(this.currentSelectedDate, '', 8) + " 00:00:00",
                endDate: this.$util.formatDate(this.currentSelectedDate, '', 8) + " 23:59:59",
                transactionStatus: '100',
                page: 1,
                size: 1000,
                timezone: -d.getTimezoneOffset() / 60,
                searchChannel: data.searchChannel || '' //渠道类型
            });
        },

        //一个接口所有数据会经常超时，所以拆分成8个请求（一个汇总请求，7个渠道请求）
        ajaxPromiseAll: function ajaxPromiseAll(done) {
            var _this4 = this;

            var channelList = this.channel.map(function (el) {
                return _this4.getChannelSum({ searchChannel: el == 'total' ? '' : el });
            });
            Promise.all(channelList).then(function (result) {
                done == undefined ? '' : done();
                _this4.$ajax.handleAjaxResult(_this4, result);
                _this4.processData(result);
            }).catch(function (err) {
                //console.log('home=>getlist=>err: ',err);
                //console.log('home=>getlist=>err.status: ',err.status);
                _this4.$ajax.handleAjaxError(_this4, err);
            });
        }
    },
    watch: {},
    mounted: function mounted() {
        this.getlist();
        this.init();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40899f75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
var home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-home footer_show",class:{'header_show':_vm.$util.myBrowser() != 'micromessenger'}},[(_vm.$util.myBrowser() != 'micromessenger')?_c('page-header',{attrs:{"pageinfo":_vm.pageInfo}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-topbar",staticStyle:{"background-color":"#fff","height":"65px","border-bottom":"1px solid #ccc"}},[_c('div',{staticClass:"f-textItem",staticStyle:{"display":"inline-block","margin-left":"10px","margin-top":"5px","color":"#6e6a6a"}},[_c('p',{staticClass:"f-amountTitle",staticStyle:{"font-size":"14px"}},[_vm._v("\n                               "+_vm._s(_vm.userInfo.merchantName)+"\n                            ")]),_vm._v(" "),_c('p',{staticClass:"f-amountTitle",staticStyle:{"font-size":"14px","margin-bottom":"5px","margin-top":"5px"}},[_vm._v("\n                                "+_vm._s(_vm.userInfo.merchantNo)+"\n                            ")])]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#f5f5f5","height":"35px","display":"inline-block"}},[_c('div',{staticStyle:{"height":"45px","line-height":"45px","position":"absolute","right":"10px"},on:{"click":_vm.tapCanlendar}},[_c('label',{staticStyle:{"margin-right":"5px","font-size":"15px"}},[_vm._v(_vm._s(_vm.currentSelectedDateShow))]),_vm._v(" "),_c('Icon',{staticStyle:{"font-size":"20px"},attrs:{"type":"calendar"}})],1),_vm._v(" "),_c('calendar',{attrs:{"defaultDate":_vm.defaultDate,"format":"yyyy/MM/dd"},on:{"change":_vm.handelChange},model:{value:(_vm.calendarShow),callback:function ($$v) {_vm.calendarShow=$$v},expression:"calendarShow"}})],1)]),_vm._v(" "),_c('on-scroll',{attrs:{"on-refresh":_vm.onRefresh,"on-infinite":_vm.onInfinite,"dataList":_vm.scrollData}},[_c('ul',{staticClass:"m-cells m-cells-total",staticStyle:{"background-color":"#26a2ff","width":"100%"}},[_c('li',{staticClass:"m-cell-total-tab"},[_c('div',[_c('div',{staticClass:"m-cell-total-tab-unit m-cell-total-tab-unit-left"},[_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("QUANTITY")]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("SALES")]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("TIPS")]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("TAX")]),_vm._v(" "),(_vm.totalMap.customTaxAmount)?_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("CUSTOM TAX")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("CONVENIENCE FEE")]),_vm._v(" "),(_vm.totalMap.otherFeeAmount)?_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("OTHER FEE")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("SVC")]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("REFUND")]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("VOID")]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-title"},[_vm._v("NET SALES")])]),_vm._v(" "),_c('div',{staticClass:"m-cell-total-tab-unit m-cell-total-tab-unit-right"},[_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.netSalesCounts))+" ")])]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.salesAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.tipAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.taxAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]),_vm._v(" "),(_vm.totalMap.customTaxAmount)?_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.customTaxAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.convenientFeeAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]),_vm._v(" "),(_vm.totalMap.otherFeeAmount)?_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.otherFeeAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.svc))+" ")]),_vm._v(_vm._s(_vm.currency))]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',{staticStyle:{"color":"#fff"}},[(_vm.totalMap.refundAmount >0)?_c('span',{staticStyle:{"margin-right":"-5px"}},[_vm._v("-")]):_vm._e(),_vm._v("\n                                "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.refundAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.voidAmount))+" ")]),_vm._v(_vm._s(_vm.currency))]),_vm._v(" "),_c('p',{staticClass:"m-cell-total-tab-unit-content"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("ifnulltozero")(_vm.totalMap.netSalesAmount))+" ")]),_vm._v(_vm._s(_vm.currency))])])])])]),_vm._v(" "),_c('ul',{staticClass:"f-datalist m-cells",staticStyle:{"background-color":"#f5f5f5"}},[_c('AmountSummary',{attrs:{"titles":['Sales','Qty','Amount'],"counts":_vm.sales.counts,"values":_vm.sales.amounts,"columnNames":_vm.sales['columnNames'],"currency":_vm.currency}}),_vm._v(" "),_c('AmountSummary',{attrs:{"titles":['Tip','Qty','Amount'],"counts":_vm.tip.counts,"values":_vm.tip.amounts,"columnNames":_vm.tip['columnNames'],"currency":_vm.currency}}),_vm._v(" "),_c('AmountSummary',{attrs:{"titles":['Tax','Qty','Amount'],"counts":_vm.tax.counts,"values":_vm.tax.amounts,"columnNames":_vm.tax['columnNames'],"currency":_vm.currency}}),_vm._v(" "),_c('AmountSummary',{attrs:{"titles":['Convenience Fee','Qty','Amount'],"counts":_vm.convenientFee.counts,"values":_vm.convenientFee.amounts,"columnNames":_vm.convenientFee['columnNames'],"currency":_vm.currency}}),_vm._v(" "),(_vm.showOtherFeeAmount)?_c('AmountSummary',{attrs:{"titles":['Other Fee','Qty','Amount'],"counts":_vm.otherFeeAmount.counts,"values":_vm.otherFeeAmount.amounts,"columnNames":_vm.otherFeeAmount['columnNames'],"currency":_vm.currency}}):_vm._e(),_vm._v(" "),(_vm.showCustomTax)?_c('AmountSummary',{attrs:{"titles":['Custom Tax','Qty','Amount'],"counts":_vm.customTax.counts,"values":_vm.customTax.amounts,"columnNames":_vm.customTax['columnNames'],"currency":_vm.currency}}):_vm._e(),_vm._v(" "),_c('AmountSummary',{attrs:{"titles":['Refund','Qty','Amount'],"counts":_vm.refund.counts,"values":_vm.refund.amounts,"columnNames":_vm.refund['columnNames'],"currency":_vm.currency}}),_vm._v(" "),_c('AmountSummary',{attrs:{"titles":['Void','Qty','Amount'],"counts":_vm.voids.counts,"values":_vm.voids.amounts,"columnNames":_vm.voids['columnNames'],"currency":_vm.currency}})],1)])],1),_vm._v(" "),_c('page-footer')],1)}
var home_staticRenderFns = []
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var views_home = (home_esExports);
// CONCATENATED MODULE: ./src/views/home.vue
function home_injectStyle (ssrContext) {
  __webpack_require__("j6Se")
}
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = home_injectStyle
/* scopeId */
var home___vue_scopeId__ = "data-v-40899f75"
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  home,
  views_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)

/* harmony default export */ var src_views_home = __webpack_exports__["default"] = (home_Component.exports);


/***/ }),

/***/ "YJVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j6Se":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.51c84d3437b48a93162b.js